import { Phone } from '@/modules/accredited-establishments/api/types'
import { WParagraph } from '@alice-health/wonderland-react'
import { FunctionComponent } from 'react'
import { ContactNumbers } from '../ContactNumbers'
import { CassiCard } from '@/modules/accredited-establishments/components'

interface ContactSectionProps {
  phones?: Phone[]
  isCassi: boolean
}

const ContactSection: FunctionComponent<ContactSectionProps> = ({
  phones,
  isCassi
}) => {
  return (
    <div className='flex flex-col gap-8'>
      {phones && phones.length > 0 ? (
        <div>
          <WParagraph className='mb-2'>Contato</WParagraph>

          <WParagraph mode='secondary'>
            <ContactNumbers phones={phones} />
          </WParagraph>
        </div>
      ) : null}

      {isCassi ? (
        <div>
          <CassiCard />
        </div>
      ) : null}
    </div>
  )
}

export { ContactSection }
